import { type VoidFunctionComponent } from 'react';

import { HIDE_FOSSABOT_PROMO } from '../../../../shared/featureFlags/flagNames';
import { useIsFeatureEnabled } from '../../../helpers/features/featureFlags';
import { openInNewTab } from '../../../utils';
import DismissibleCardBanner, { CardBannerVariant } from '../../generic/CardBanner/DismissibleCardBanner';
import icons from '../../generic/Icon/icons';

import css from './FossabotAlphaAd.module.less';

const DISMISSED_KEY = 'fossabotAlphaAdDismissed';

const FossabotAlphaAd: VoidFunctionComponent = () => {
  const shouldHideFossabotPromo = useIsFeatureEnabled(HIDE_FOSSABOT_PROMO);

  if (shouldHideFossabotPromo) {
    return null;
  }

  return (
    <div>
      <DismissibleCardBanner
        dismissKey={DISMISSED_KEY}
        variant={CardBannerVariant.PROMO}
        headerImage={{
          src: '/img/fossabot-logo-color.svg',
          alt: 'fossabot logo',
        }}
        title="Announcing fossabot"
        description="Automated dependency updates with breaking changes and app impact analysis, right in GitHub."
        cta={{
          text: 'Learn more',
          icon: icons.externalLink,
          onClick: () => openInNewTab('https://fossa.com/products/fossabot/?utm_source=fossa-scan&utm_medium=web&utm_campaign=fossabot-ad'),
          isFullWidth: true,
        }}
        classes={css}
    />
    </div>
  );
};

export default FossabotAlphaAd;
